export enum SeverityEnum {
  NONE = 'none',
  MILD = 'mild',
  MEDIUM = 'medium',
  SEVERE = 'severe',
  FATAL = 'fatal',
}

export enum IssueCategoryEnum {
  BAD_LIGHTING = 'badLighting',
  INTERNAL = 'internal',
  FLEXION = 'flexion',
  STRIDES = 'strides',
  OCCLUSION = 'occlusion',
  DETECTION = 'detection',
  TROTTING = 'trotting',
  CAMERA = 'camera',
  OTHER = 'other',
  LONGEING = 'longeing',
  RIDER = 'rider',
  DISTANCE = 'distance',
  FEATURE_NOT_READY = 'featureNotReady',
  NONE = 'none',
  CAMERA_POSITION = 'cameraPosition',
  YOLO_TRACKING = 'yoloTracking',
  COMPRESSION = 'compression',
  GAIT = 'gait',
  LENGTH = 'length',
}

export enum SeverityLevelEnum {
  NONE = 0,
  MILD = 0,
  MEDIUM,
  SEVERE,
  FATAL,
}
